// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"518":"d22bdf2b6c8137d3","3560":"c8eef80af7f47a8b","9565":"909e99ad2a275fcd"}[chunkId] + ".js";
};